import attendance from "./attendance";
import employment from "./employment";
import expo from "./expo";
import meetings from "./meetings";
import recruitmentApplications from "./recruitment-applications";
import resume from "./resume";

export default {
    attendance,
    employment,
    expo,
    meetings,
    recruitmentApplications,
    resume,
};
